// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".debug-json[data-v-595c1ba4]{max-height:400px;overflow-y:auto;background-color:#f5f5f5;padding:12px;border-radius:4px;font-family:\"Roboto Mono\",monospace;font-size:12px;line-height:1.4}.theme--dark .debug-json[data-v-595c1ba4]{background-color:#1e1e1e;color:#d4d4d4}pre[data-v-595c1ba4]{white-space:pre-wrap;word-break:break-word}", ""]);
// Exports
module.exports = exports;
